import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock`;

export async function getStocks() {
  const res = await apiFetch(BASE_URL);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createStock(payload) {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateStock(id, payload) {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteStock(id) {
  return apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
}

export async function getStockCoverage(id) {
  const res = await apiFetch(`${BASE_URL}/${id}/coverage`);
  if (!res.ok) return { sectors: [], countries: [] };
  return res.json();
}

export async function updateStockCoverage(id, payload) {
  const res = await apiFetch(`${BASE_URL}/${id}/coverage`, {
    method: "PUT",
    body: JSON.stringify(payload || { sectors: [], countries: [] }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to save stock coverage");
  }
  return res.json();
}

export async function fetchStockCapCategory(id) {
  const res = await apiFetch(`${BASE_URL}/${id}/cap-category/fetch`, {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to fetch cap category");
  }
  return res.json();
}

export async function recomputeCapCategories() {
  const res = await apiFetch(`${BASE_URL}/cap-category/recompute`, {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to recompute cap categories");
  }
}

export async function refreshCapCategoriesFromNse() {
  const res = await apiFetch(`${BASE_URL}/cap-category/refresh`, {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to refresh cap categories");
  }
  return res.json();
}

export async function refreshCoverageFromNse() {
  const res = await apiFetch(`${BASE_URL}/coverage/refresh/nse`, {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to refresh coverage");
  }
  return res.json();
}

export async function startQuoteCapRefresh() {
  const res = await apiFetch(`${BASE_URL}/cap-category/refresh/quotes`, {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to start cap refresh job");
  }
  return res.json();
}

export async function getCapRefreshStatus() {
  const res = await apiFetch(`${BASE_URL}/cap-category/refresh/status`);
  if (!res.ok) {
    return { running: false };
  }
  return res.json();
}
